import { useEffect, useState, useCallback } from "react"
import { useSelector } from 'react-redux';
import { ICONS } from "@/modules/ui-elements/Icon";
import useEditorService from "@/hooks/useEditorService";
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking.js";
import { EventTrackName } from "@/modules/segment-event-tracking/constant.js";
import { 
         aiBackgroundUrlsAtoms,
         aigenerationLayerProgressAtom,
         homepageFeatureAtom,
         segmentEventPayload,
         activeProjectAtom,
         searchAssetKeywordAtom,
         } from "../../Atoms";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import AIBackgrounds from "../AIBackgrounds";
import { getAssets } from "../../services/Assets";
import { useSearchParams } from "next/navigation";
import useResetAtomHandler from "@/modules/editor-v2/resetAtomHandler";
import { css } from "@emotion/react";
import UploadAssets from "../MyAssets/UploadAssets";
import { useQuery } from "@tanstack/react-query";

export const TEMPLATE_TYPE={
    RECENT:"recentused",
    FAVOURITE:'yourfavorite',
    ALL:'all'
};

export const BACKGROUND_MODE={
    BASIC:"basic",
    SELECTANGLE:'selectangle',
};

export const FORMAT_TYPES=[
    {
        type:'Square',
        title:'Square',
        aspectRatio: "1/1",
        icon:ICONS.squareLight,
        lightIcon:ICONS.squareLight
    },
    {
        type:'Landscape',
        title:'Landscape',
        aspectRatio: "16/9",
        icon:ICONS.landscapeLight,
        lightIcon:ICONS.landscapeLight

    },
    {
        type:'Portrait',
        title:'Portrait',
        aspectRatio: "9/16",
        icon:ICONS.portraitLight,
        lightIcon:ICONS.portraitLight

    },
]

export const filterObject = {
    searchString:[],
    searchText:'',
    selectedFormat:FORMAT_TYPES[0],
    imageFormat:[FORMAT_TYPES[0].title],
    colors:[],
    hotspotOnly: false,
    updateRecentSearch:false,
    lifestyleImages:false,
    isInfographics:false,
    prespective:{}
};


export default function Templates() {
    const {activeEditor} = useEditorService();
    const [isAIBackgrounds, setIsAIBackgrounds] = useState(false);
    const searchAssetKeyword = useAtomValue(searchAssetKeywordAtom);
    const {deleteBackground} = useEditorService();
    const [attributePage, setAttributePage] = useState(false)
    const searchParams = useSearchParams();
    const aiBackgroundUrls = useAtomValue(aiBackgroundUrlsAtoms);
    const {resetPromptHandler} = useResetAtomHandler();
    const aigenerationLayerProgress = useAtomValue(aigenerationLayerProgressAtom); 
    const [homepageFeature, setHomepageFeature] = useAtom(homepageFeatureAtom);
    const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
    const activeProject = useAtomValue(activeProjectAtom);
    const {entireStrapiData} = useSelector((state)=> state.strapi)
    const strapiData = entireStrapiData?.StudioAssestData?.StudioAssestData;
    const {data: assets, isLoading, isError} = useQuery({
        queryKey: ["assets",searchAssetKeyword],
        queryFn: getAssets,
    });

    const bannerOnClick = useCallback(async ()=>{
        if(Object.keys(getSegmentPayloadAtom).length)TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._Click_create_your_own_ai_studio}`,{...getSegmentPayloadAtom,job_id:activeProject?.job_id});
        deleteBackground()
        setAttributePage(false)
        setIsAIBackgrounds(true)
      },[deleteBackground])

    useEffect(()=>{
        if(!activeEditor)
        return
        const layers = activeEditor.layerManager._layers.value.filter(layer=>layer.getTags()?.includes("product-image"));
        !layers.length && resetPromptHandler();
        if ((searchParams.has("AI-backgrounds")&&!homepageFeature)|| aigenerationLayerProgress ) { //Need to open AIBackgrounResults directly for AI-background jobs from homepage, website and tab switch
            setHomepageFeature("AI-Backgrounds")
            bannerOnClick();
        }
        if(!aigenerationLayerProgress && !aiBackgroundUrls?.length && !searchParams.has("AI-backgrounds"))
        {
            setIsAIBackgrounds(false);
        }
        if(layers.filter(layer=>layer.getTags()?.includes("product-image"))){
            bannerOnClick();
        }
    },[])

    if(isAIBackgrounds && activeEditor?.layerManager._layers.value.filter(layer=>layer.getTags()?.includes("product-image")).length) return <AIBackgrounds setIsAIBackgrounds={setIsAIBackgrounds} setAttributePage={setAttributePage} attributePage={attributePage} getSegmentPayloadAtom={getSegmentPayloadAtom} activeProject={activeProject}/>

    return <> <div style={styles.container}>
        <div css={styles.headerContainer}>
            <div css={styles.titleContainer} >
                {strapiData?.AIbackgrounds || "AI Backgrounds"}
            </div>
            <div css={styles.divider}></div>
            {Array.isArray(assets) && assets.length > 0 && <div css={styles.textContainer}>{strapiData?.SelectAsset || "Select an asset to place it on the canvas"}</div>}
        </div>
        <UploadAssets isSelected={"FALSE"} autoApply={true} setIsAIBackgrounds={bannerOnClick}/> 
    </div>
    </>
}

const styles = {
    container : { 
        height:"100%", display:'flex', flexDirection:"column"
    },
    divider: {
        height: "0.5px",
        background: "rgba(255, 255, 255, 0.24)"
    },
    textContainer: css`
    font-weight: 500;
    font-size: 14px;
    line-height: 160%;
    display: flex;
    align-items: center;
    padding: 15px 10px 5px 10px;
  `,
  titleContainer: css`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    padding: 15px 10px;
    letter-spacing: 1%;
  `,
  topRow: css`
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index:100;
  `,
  headerContainer: css`
    display: flex;
    flex-direction: column;
    color: #eeeeee;
  `,
}